import { type ReactNode, useState } from 'react';
import { cn } from '@/utils/cn';
import type { TeamMember } from '../types';

function verificationUrl(m: TeamMember): string | undefined {
  if (!m.verification_photo) return undefined;
  return `/api/files/team_members/${m.id}/${m.verification_photo}`;
}

function PhotoFallback({ name }: { name: string }): ReactNode {
  return (
    <div className="absolute inset-0 flex items-center justify-center bg-surface-secondary text-4xl font-medium text-text-secondary">
      {name.slice(0, 2).toUpperCase()}
    </div>
  );
}

function statusFilter(status: string | undefined): string {
  if (status === 'banned' || status === 'failed') return 'grayscale';
  if (status === 'redemption_test') return 'saturate-50';
  return '';
}

export function PhotoLayer({ member }: { member: TeamMember }): ReactNode {
  const [imgError, setImgError] = useState(false);
  const src = verificationUrl(member);
  if (!src || imgError) return <PhotoFallback name={member.first_name} />;
  return (
    <img
      src={src}
      alt={member.first_name}
      className={cn(
        'absolute inset-0 h-full w-full object-cover object-center',
        statusFilter(member.account_status)
      )}
      onError={() => setImgError(true)}
    />
  );
}
